module.exports = __webpack_public_path__ + "static/media/arrow-down-svgrepo-com.179053fa.svg";